module.exports = __webpack_public_path__ + "static/media/432058578_395282006593163_5264500940304846757_n.cd469a83.jpg";